module.exports = __webpack_public_path__ + "assets/711f5e7e1359440adf9c2e4959df574b.svg";